import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrichadmin.admin.models');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-nrichadmin-admin-models',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichadminAdminModelsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public configs: any[] = [];
    public loading: boolean = true;
    public editItem: any = null;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call("model_configs");
        if (code === 200) {
            this.configs = Array.isArray(data) ? data : [];
        }
        this.loading = false;
        await this.service.render();
    }

    public edit(item: any) {
        this.editItem = JSON.parse(JSON.stringify(item));
        this.service.render();
    }

    public cancelEdit() {
        this.editItem = null;
        this.service.render();
    }

    public async save() {
        if (!this.editItem) return;
        const { code } = await wiz.call("model_config_update", { data: JSON.stringify(this.editItem) });
        if (code === 200) {
            this.editItem = null;
            await this.load();
        } else {
            await this.service.alert.show({ title: '오류', message: '저장에 실패했습니다.', action: '확인' });
        }
    }

    public gradeLabel(grade: string): string {
        const labels: any = { advanced: '고급', basic: '기본', embedding: '임베딩' };
        return labels[grade] || grade;
    }

    public gradeColor(grade: string): string {
        const colors: any = {
            advanced: 'bg-purple-100 text-purple-700',
            basic: 'bg-blue-100 text-blue-700',
            embedding: 'bg-green-100 text-green-700'
        };
        return colors[grade] || 'bg-gray-100 text-gray-600';
    }
}

export default PortalNrichadminAdminModelsComponent;